export { default } from '@fhs-legacy/frontend/src/pages/support-v2/support-v2-orders-list-page';
